module.exports = __webpack_public_path__ + "static/media/vino-5.ccb17f2b.jpg";